const Nbsp = () => {
  return ' ';
};

export default Nbsp;
